import { useContext, useMemo } from "react";
import { useLocation } from "react-router";
import { channelsContext } from "../constants/contexts";
import { BCP, BCPPYME } from "../constants/channels";

export const useChannel = () => {
    const channels = useContext(channelsContext);
    const { pathname } = useLocation();
    const normalizedPathname = useMemo(
        () => channels.normalizePath(pathname),
        [channels.normalizePath, pathname]
    );
    const isBcpTheme = useMemo<boolean>(
        () =>
            (channels.channel && channels.channel.toLowerCase() === BCP) ||
            (channels.channel && channels.channel.toLowerCase() === BCPPYME),
        [channels.channel]
    );
    return {
        ...channels,
        normalizedPathname,
        isBcpTheme,
    };
};
